// Auth layout — standalone, no topbar/sidebar. Wraps /signin per DESIGN.md §8.1
// ("single full-viewport centered hero card"). Styling is deliberately minimal
// here; task 43 owns the visual treatment.

import { Outlet } from "react-router-dom";

export function AuthLayout(): JSX.Element {
  return (
    <main className="auth-layout">
      <Outlet />
    </main>
  );
}
